import React from "react";
import { Badge } from "flowbite-react";
import Loading from "../../components/Loading";
import { Link } from "react-router-dom";

export const RETURN_OUTLINE = [
  { api_name: "Name", show_name: "Return ID" },
  { api_name: "Sales_Return_Date", show_name: "Return Date" },
  { api_name: "CP_Purchase", show_name: "Order Id" },
  { api_name: "Return_Status", show_name: "Status" },
  { api_name: "Return_Reason", show_name: "Reason" },
  { api_name: "Grand_Total", show_name: "Total Return Value" },
];

const ReturnLists = ({ isLoading, returns, setSearchValues }) => {
  const handleApiCall = (selectedValue) => {
    setSearchValues((searchValues) => {
      return {
        ...searchValues,
        ["Stage"]: selectedValue,
        page: 1,
      };
    });
    // console.log("Selected value:", selectedValue);
  };

  return (
    <div className="max-w-full relative overflow-x-auto shadow-md sm:rounded-lg">
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            {RETURN_OUTLINE.map(({ show_name }) => (
              <th key={show_name} scope="col" className="px-6 py-3 text-center">
                {show_name === "Status" ? (
                  // <select
                  //   className="p-1 text-center border-0 focus:outline-0 focus:ring-0 focus:border-transparent text-sm bg-gray-50"
                  //   onChange={(e) => handleApiCall(e.target.value)}
                  // >
                  //   <option value="">Select Status</option>
                  //   {/* You can add your stage options here */}
                  //   <option value="Pending">Pending</option>
                  //   <option value="Approved">Approved</option>
                  //   <option value="Rejected">Rejected</option>
                  //   <option value="Processing">Processing</option>
                  //   <option value="Completed">Completed</option>
                  // </select>

                  <input
                    className="w-[100px] border border-gray-300 rounded-md p-1 px-2"
                    onChange={(e) => handleApiCall(e.target.value)}
                    placeholder="Status"
                  />
                ) : (
                  show_name
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {!isLoading && !returns?.length ? (
            <tr>
              <td colSpan={RETURN_OUTLINE.length} className="text-center">
                <h1>No Return Records Found</h1>
              </td>
            </tr>
          ) : isLoading ? (
            <tr>
              <td colSpan={RETURN_OUTLINE.length} className="text-center">
                <Loading />
              </td>
            </tr>
          ) : (
            returns?.map?.((returnRecord) => (
              <tr
                key={returnRecord?.id}
                className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                {RETURN_OUTLINE.map(({ api_name }) => (
                  <td
                    key={api_name}
                    className="px-6 py-4 max-w-32 overflow-x-auto custom-scrollbar"
                  >
                    {api_name === "CP_Purchase" ? (
                      returnRecord?.[api_name]?.name ?? "N/A"
                    ) : api_name === "Return_Status" ? (
                      <span className="inline-block">
                        <Badge
                          className="shadow-md"
                          color={`${
                            returnRecord[api_name] === "Approved"
                              ? "success"
                              : returnRecord[api_name] === "Rejected"
                              ? "failure"
                              : "warning"
                          }`}
                        >
                          {returnRecord[api_name]}
                        </Badge>
                      </span>
                    ) : api_name === "Name" ? (
                      <Link
                        className={`font-semibold`}
                        to={`/return-history/${returnRecord?.id}`}
                      >
                        {returnRecord[api_name]}
                      </Link>
                    ) : api_name === "Grand_Total" ? (
                      <span className="text-right block pr-5">
                        {returnRecord[api_name] ?? "N/A"}
                      </span>
                    ) : (
                      returnRecord[api_name] ?? "N/A"
                    )}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReturnLists;
